import axios from 'axios'
import { API_BASE_URL } from '../config'
import { getAuthDetails } from './api' // Adjust the path as needed
// axInsecure.interceptors.request.use
/**
 * Axios request interceptor for `axInsecure` instance.
 * Adds `controller_id` (from logged-in user) to request query parameters if available.
 * Ensures credentials are excluded for non-authenticated API usage.
 *
 * @param {Object} config - Axios request configuration object.
 * @returns {Object} Modified request configuration with appended controller_id if available.
 */
const axInsecure = axios.create({
	baseURL: API_BASE_URL,
	withCredentials: false // Do not include credentials
})

// Add an interceptor to include controller_id and app_type
axInsecure.interceptors.request.use(
	(config) => {
		const { loggedInUserId } = getAuthDetails()
		if (loggedInUserId) {
			const params = new URLSearchParams(config.params || {})
			params.append('controller_id', loggedInUserId)
			config.params = params
		}
		return config
	},
	(error) => Promise.reject(error)
)

export default axInsecure
